import React from 'react';
import PropTypes from 'prop-types';

import { withTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconDocuments = ({ theme, ...otherProps }) => (
  <SvgIcon {...otherProps} viewBox="0 0 84.89904 101.58588">
    <path fill={theme.palette.primary[500]} d="m14.15 91.137c-1.9457 0-3.5374-1.5919-3.5374-3.5374v-77.47l-1.7687-0.35384h-5.3063c-1.9456 0-3.5374 1.5919-3.5374 3.5374v84.899c0 1.9457 1.5919 3.5374 3.5374 3.5374h67.212c1.9457 0 3.5376-1.5917 3.5376-3.5374v-5.3061l-0.177-1.7687h-59.96v0.000163z" />
    <path fill={theme.palette.primary[150]} d="m84.899 21.388h-17.687c-1.9457 0-3.5374-1.5919-3.5374-3.5374v-17.687h-49.524c-1.9457 0-3.5374 1.5917-3.5374 3.5374v84.899c0 1.9456 1.5917 3.5374 3.5374 3.5374h67.212c1.9457 0 3.5374-1.5919 3.5374-3.5374v-67.212h-0.000163z" />
    <g fill={theme.palette.common.white}>
      <path d="m66.5 39h-39c-1.381 0-2.5-1.343-2.5-3 0-1.6568 1.1193-3 2.5-3h39c1.381 0 2.5 1.343 2.5 3s-1.1193 3-2.5002 3" />
      <path d="m67.131 50.955h-39c-1.3807 0-2.5-1.3432-2.5-3s1.1193-3 2.5-3h39c1.3807 0 2.5 1.3432 2.5 3 0 1.6566-1.1193 3-2.5002 3" />
      <path d="m67.131 62.156h-39c-1.3807 0-2.5-1.3432-2.5-3s1.1193-3 2.5-3h39c1.3807 0 2.5 1.3432 2.5 3s-1.1193 3-2.5002 3" />
      <path d="m67.131 74.016h-39c-1.3807 0-2.5-1.3432-2.5-3s1.1193-3 2.5-3h39c1.3807 0 2.5 1.3432 2.5 3s-1.1193 3-2.5002 3" />
    </g>
    <path fill={theme.palette.primary[500]} d="m84.899 21.388h-17.687c-1.9457 0-3.5374-1.5919-3.5374-3.5374v-17.687l21.225 21.225z" />
  </SvgIcon>
);

IconDocuments.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        150: PropTypes.string.isRequired,
        500: PropTypes.string.isRequired,
      }).isRequired,
      common: PropTypes.shape({
        white: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme()(IconDocuments);



// WEBPACK FOOTER //
// ./src/components/icons/IconDocuments.js